/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-04-22 15:28:36
 * @FilePath: /91qs_answer_frontpro/src/pages/questionnaire/js/questionContent.js
 */
import AnswerValidity from "@/components/AnswerValidity";
import QTitle from "@/components/QTitle";
import BaseCheckbox from "@/pages/checkbox/BaseCheckbox";
import BaseInput from "@/pages/input/BaseInput";
import MatrixInput from "@/pages/input/MatrixInput";
import Matrix from "@/pages/matrix";
import Age from "@/pages/other/Age";
import City from "@/pages/other/City";
import CityWeb from "@/pages/other/City/Web";
import BaseRadio from "@/pages/radio/BaseRadio";
import DropdownRadio from "@/pages/radio/DropdownRadio";
import BaseSlider from "@/pages/slider/BaseSlider";
import UploadFile from "@/pages/uploadFile";
import Phone from "@/pages/other/Phone";
import AiChat from "@/pages/aiChat";
import {get} from "lodash";
import React, {Fragment, useEffect, useState} from "react";
import styles from "../less/questionContent.module.less";
import {language} from "@/utils/language";
import {
    isMatrixCheckboxType,
    isMatrixInputype,
    isMatrixRadioType,
} from "./answerType";

const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

const QuestionContent = ({info, surveyId, sampleId, answer, changeAnswer, themeId}) => {

    console.log("当前题型: ", info.model, "当题答案: ", answer);
    const {optionForm, limit, pcH5Setting} = info.preferences?.childPrefer || {};
    const [iframeSrc, setIframeFrc] = useState('');
    const isMinimalTheme = Number(themeId) === 4;
    ///////////////页面第二组件 包裹手机和 PC 判断逻辑
    const Component =
        {
            dropdown_radio: DropdownRadio,
            base_radio: BaseRadio,
            base_checkbox: BaseCheckbox,
            upload_other: UploadFile, // 上传题
            base_input: BaseInput,
            matrix_radio: isMatrixRadioType(optionForm, limit, pcH5Setting),
            matrix_checkbox: isMatrixCheckboxType(optionForm, pcH5Setting),
            matrix_input: isMobile ? MatrixInput : isMatrixInputype(optionForm, pcH5Setting),
            explain: Fragment,
            newscore_radio: BaseSlider,
            age: Age,
            city: isMobile ? City : CityWeb,
            text_radio: Fragment,
            text_checkbox: Fragment,
            phone: Phone,
            ai_chat: AiChat
        }[get(info, "model")] || Matrix;

    useEffect(() => {
        window.scrollTo(0, 0);
        getSrc(info.description);
    }, [info]);

    // 取出iframe 标签
    const getInfo = (info) => {
        const copyInfo = JSON.parse(JSON.stringify(info));
        copyInfo.description = copyInfo.description.replace(/<a href=".*<\/a>/g, '');
        return copyInfo;
    }
    // 取出iframe的src
    const getSrc = (des) => {
        try {
            let str = des.match(/href="(.*?)"/g)[0].match(/http.*/g)[0];
            if (str) {
                const resSrc = str.slice(0, str.length - 1);
                setIframeFrc(resSrc);
            } else {
                setIframeFrc('');
            }
        } catch (error) {
            setIframeFrc('');
        }
    }
    const ModifyDataTotal = (infos) => {
        // 处理加总
        let _infos = JSON.parse(JSON.stringify(infos))


        let _direction = _infos.preferences.childPrefer.direction
        if (_infos.model == "matrix_input") {
            if (!isMobile && !_direction) {

                if (_infos.preferences.optionPrefer.optionSumView && (_infos.preferences.optionPrefer.optionSumType == 0 || _infos.preferences.optionPrefer.optionSumType == 2)) {
                    let _childs = {
                        ..._infos.childs[0],
                        description: language().total,
                        data_total: 1,
                        id: _infos.childs[0].id + "_input_total",
                        moduleOption: 0,
                    };
                    _infos.childs.push(_childs);
                }
                if (_infos.preferences.optionPrefer.optionSumView && (_infos.preferences.optionPrefer.optionSumType == 1
                    || _infos.preferences.optionPrefer.optionSumType == 2)
                ) {

                    _infos.childs.forEach(element => {
                        let _infosOptions = {
                            ...element.options[0],
                            moduleOption: 0,
                            id: element.options[0].id + "_input_total",
                            data_total: 1
                        };
                        element.options = [...element.options, _infosOptions]
                    });

                    let _infosOptions = {
                        ..._infos.options[0],
                        description: language().total,
                        moduleOption: 0,
                        data_total: 1
                    };

                    _infos.options = [..._infos.options, _infosOptions]

                }

            } else {

                if (_infos.preferences.optionPrefer.optionSumView && (_infos.preferences.optionPrefer.optionSumType == 1 || _infos.preferences.optionPrefer.optionSumType == 2)) {
                    let _childs = {
                        ..._infos.childs[0],
                        description: language().total,
                        data_total: 1,
                        id: _infos.childs[0].id + "_input_total",
                        moduleOption: 0,
                    };

                    if (isMobile && _infos.preferences.optionPrefer.optionSumType == 2) {
                        let _childs = {
                            ..._infos.childs[0],
                            description: language().total,
                            data_total: 1,
                            id: _infos.childs[0].id + "_input_total",
                            moduleOption: 0,
                            options: []
                        };
                        _infos.childs.push(_childs);
                    }
                    if (!isMobile) {
                        _infos.childs.push(_childs);
                    }
                }

                if (_infos.preferences.optionPrefer.optionSumView && (_infos.preferences.optionPrefer.optionSumType == 0
                    || _infos.preferences.optionPrefer.optionSumType == 2)
                ) {
                    let _infosOptions = {
                        ..._infos.options[0],
                        description: language().total,
                        id: _infos.options[0].id + "_input_total",
                        moduleOption: 0,
                        data_total: 1
                    };
                    _infos.options = [..._infos.options, _infosOptions]
                }
            }

        }
        console.log('_infos_infos_infos_infos', _infos);
        return _infos
    }
    const wrapperClassName = `${styles.wrapper} ${isMinimalTheme ? styles.minimal : ''}`;
    return (
        <div className={wrapperClassName}>
            {
                // 7 是 <p></p>的长度 防止显示空的模块
                (getInfo(info).description?.length > 7 || getInfo(info).groupCode?.length > 0) && (
                    <CloneCom id={info.id}>
                        <QTitle
                            info={getInfo(info)}
                            answer={answer}
                            changeAnswer={changeAnswer}
                            showImageViewer={optionForm !== 5 && optionForm !== 6}
                            themeId={themeId}
                            isMinimalTheme={isMinimalTheme}
                        />
                    </CloneCom>
                )
            }
            {Component === Fragment ? (
                iframeSrc !== '' && <iframe src={iframeSrc} width="100%" height={500}></iframe>
                // <Fragment />
            ) : (
                <AnswerValidity info={ModifyDataTotal(info)} answer={answer} changeAnswer={changeAnswer}>
                    <Component
                        surveyId={surveyId}
                        sampleId={sampleId}
                        info={ModifyDataTotal(info)}
                        answer={answer}
                        changeAnswer={changeAnswer}
                        themeId={themeId}
                        isMinimalTheme={isMinimalTheme}
                    />
                </AnswerValidity>
            )}
            <>
            </>
        </div>
    );
};

function CloneCom(props) {
    const getChildren = () => {
        let {children} = props;
        return React.Children.map(children, (child) => {
            return React.cloneElement(child);
        });
    };
    return <div id={props?.id}> {getChildren()}</div>;
}

export default QuestionContent;
